import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

export const InterceptorSkipHeader = 'Digital-Ui-Lib-Version';

export const removeVersionInterceptorFn: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  console.log('REMOVE CALLED');
  const modifiedReq = req.clone({
    headers: req.headers.delete(InterceptorSkipHeader),
  });
  return next(modifiedReq);
};
